export const CANDIDATE_SOURCE = [
  {
    id: 'OPTAVIA_WEB',
    name: 'Leads Pool',
  },
  {
    id: 'COACH_APP',
    name: 'Coach App',
  },
  {
    id: 'FACEBOOK',
    name: 'Facebook',
  },
  {
    id: 'LIFEMD',
    name: 'LifeMD',
  },
  {
    id: 'CLIENT_REFERRAL',
    name: 'Client Referral',
  },
];
